import { ExpandLess, ExpandMore, Info } from '@mui/icons-material'
import { Box, Typography, useTheme } from '@mui/material'

import useGetAgentCentralized from '~/features/agents/hooks/useGetAgentCentralized'
import { EAgentKeys } from '~/features/agents/models'
import { ECapability } from '~/features/user/models'
import useCapabilities from '~/hooks/useCapabilities'
import { store } from '~/store'
import rem from '~/utils/ui'

type TProps = {
  hideText?: boolean
}

function ContactInfoButton({ hideText = false }: TProps) {
  const theme = useTheme()
  const { canRead } = useCapabilities()
  const { isError, selectedAgent: agent } = useGetAgentCentralized()
  const [isAgentInfoHeaderOpen, setUIElements] = store((state) => [
    state.UIElements.isAgentInfoHeaderOpen,
    state.setUIElements,
  ])

  // Same visibility as AgentInfoHeader: agent present and read access to assistant config
  if (
    isError ||
    !agent ||
    !agent[EAgentKeys.id] ||
    !canRead(ECapability.aiAssistantConfig)
  ) {
    return null
  }

  const handleClick = () => {
    setUIElements({ isAgentInfoHeaderOpen: !isAgentInfoHeaderOpen })
  }

  return (
    <Box
      component="button"
      onClick={handleClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: rem(6),
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        '&:hover': {
          opacity: 0.8,
        },
      }}
    >
      <Info sx={{ fontSize: rem(18), color: theme.palette.menuFont }} />
      {!hideText && (
        <>
          <Typography
            sx={{
              fontSize: rem(13),
              color: theme.palette.menuFont,
              fontWeight: theme.typography.fontWeightMedium,
            }}
          >
            Assistant Contact Info
          </Typography>
          {isAgentInfoHeaderOpen ? (
            <ExpandLess
              sx={{ fontSize: rem(18), color: theme.palette.menuFont }}
            />
          ) : (
            <ExpandMore
              sx={{ fontSize: rem(18), color: theme.palette.menuFont }}
            />
          )}
        </>
      )}
    </Box>
  )
}

export default ContactInfoButton
